import { UNKNOWN_VALUE } from '../constants';
import CellText from './CellText';

export interface DivisionCellProps {
  /** Pre-resolved via `useDivisionRollup().resolveDivisionName`; `undefined`
   * for a missing or unrecognised provider. */
  name: string | undefined;
}

/**
 * Division name cell: the resolved name (own Organization or a Division), or
 * `UNKNOWN_VALUE` when the provider isn't recognised (PRD D5). Owns the
 * placeholder so `useDivisionRollup` stays presentation-free.
 */
export default function DivisionCell({ name }: DivisionCellProps) {
  return <CellText text={name ?? UNKNOWN_VALUE} />;
}
